import script from "./ImageUploader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageUploader.vue?vue&type=script&lang=ts&setup=true"

import "./ImageUploader.vue?vue&type=style&index=0&id=10d43e0e&scoped=true&lang=css"

import exportComponent from "D:\\AppV5\\DangKyXetTuyen\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d43e0e"]])

export default __exports__